const HOW_TO_WIN = [
  'Winners from daily sale events are eligible to the lucky draw for grand prize.',
  'Lucky draw list will be automatically updated as soon as a sale event is over.',
  'At the end of the Big Bold Sale the draw will happen.',
  'The winners will be contacted by our executives for further procedures & reward distribution.'
];
const LINK = {
  text: 'Terms & conditions apply',
  href: 'https://www.ajio.com/help/termsAndCondition'
};
const MODAL_HEADER = 'How to win Grand Prize';
const GRAND_PAGE_HEADER = {
  preText: 'Winners will be added to the list as soon as the respective events are over.',
  postText: 'Please be patient. Name of the winners will be announced after the lucky draw.',
  noUserText: 'The leaderboard will be updated shortly. Please be patient. '
};
export { HOW_TO_WIN, LINK, MODAL_HEADER, GRAND_PAGE_HEADER };
